import { MakeCall } from './createMakeCall';

export interface Payload {
  listingId: number;
  targetLang: string;
  translator?: 'google' | 'deepl';
}

export interface ListingTranslationResponse {
  description: string;
}

const translateListingDescription =
  (makeCall: MakeCall) =>
  ({ listingId, targetLang, translator }: Payload) =>
    makeCall<ListingTranslationResponse>(
      'GET',
      `/api/v2/listing/${listingId}/translate/description/${targetLang}`,
      {
        query: {
          translator,
        },
      },
    );
export { translateListingDescription };
